import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.sort.js";
export var getManagementCompaniesOptions = function getManagementCompaniesOptions(managementCompanies) {
  return managementCompanies.sort(function (first, second) {
    return second.name < first.name ? 1 : -1;
  }).map(function (company) {
    return {
      id: company.id,
      label: company.name,
      counter: company.stats.funds
    };
  });
};